import type { Dictionary } from '@/i18n/dictionary'
import { de } from '@/i18n/locales/de'
import { en } from '@/i18n/locales/en'
import { hr } from '@/i18n/locales/hr'
import { it } from '@/i18n/locales/it'
import { sl } from '@/i18n/locales/sl'
import { sr } from '@/i18n/locales/sr'
import { tr } from '@/i18n/locales/tr'
import type { Locale } from '@/i18n/locales'
import { DEFAULT_LOCALE } from '@/i18n/locales'

export const dictionaries: Record<Locale, Dictionary> = { hr, en, de, it, sr, sl, tr }

export const getDictionary = (locale: Locale): Dictionary =>
  dictionaries[locale] ?? dictionaries[DEFAULT_LOCALE]

export const interpolate = (template: string, values: Record<string, string | number>): string =>
  template.replace(/\{(\w+)\}/g, (match, key: string) => {
    const value = values[key]
    return value === undefined ? match : String(value)
  })

export type { Dictionary } from '@/i18n/dictionary'
export * from '@/i18n/locales'
